module.exports = __webpack_public_path__ + "static/media/indriveLogo.0e884744.png";